import React from 'react';
import authService, { parsePrivilege } from '../../services/AuthService';

const showWhenPermission = (functionality, privilege = null) => {
  // functionality may be a single name/number, or an array of them (OR semantics) -
  // authService.hasPermission resolves either form, so no pre-parsing is needed here.
  const p = parsePrivilege(privilege);

  return WrappedComponent => ({ ...passThroughProps }) => {
    if (
      !authService.hasPermission({
        functionality,
        privilege: p,
      })
    )
      return null;
    return <WrappedComponent {...passThroughProps} />;
  };
};
export default showWhenPermission;

/* Used like this:
export default showWhenPermission('relation','read')(RelationOverviewContainer);
export default showWhenPermission(['relation','settings'],'read')(RelationOverviewContainer);
*/
